import { useContext, useMemo } from "react"
import UserContext from "../contexts/UserContext/context"
import { useTranslation } from "react-i18next"
import { ICON } from "../components/Icon/data"

export const useManagement = () => {
  const { t } = useTranslation()

  const { user } = useContext(UserContext)
  const { permissions } = user

  const options = useMemo(() => ([{
    label: t('Manage fleets'),
    icon: ICON.CARS,
    url: '/manage/fleet',
    permission: true
  }, {
    label: t('Manage mobiles'),
    icon: ICON.COGWHEEL,
    url: '/manage/mobiles',
    permission: permissions?.auth?.view_user
  }, {
    label: t('Sensor temperature settings'),
    icon: ICON.SENSOR_TEMPERATURE,
    url: '/manage/sensors',
    permission: true,
  }, {
    label: t('Manage users'),
    icon: ICON.USERS_MULTIPLE,
    url: '/manage/users',
    permission: true,
  }]), [t, permissions])

  const authorizedOptions = useMemo(() => {
    return options.filter((option) => option.permission)
  }, [options])

  return {
    options: authorizedOptions,
    showAdmin: authorizedOptions.length > 0
  }
}
